import React from "react";
import { getCellColor, sxStyles } from "../sharedStyles";
import { Box, SxProps, Typography } from "@mui/material";
import { IPriceItinerary } from "../interfaces.lowPrice";
import { InfoIcon } from "./InfoIcon";
import { ReturnValue } from "use-count-up";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { useTranslations } from "hooks/useTranslations";
import {
  formatCurrency,
  formatPriceNoCurrency,
  getStops,
  minutesTimeSpan,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { IStops } from "../../../hooks/translations.interfaces";

interface IProps {
  selectedItineraryId: string | null;
  priceItinerary: IPriceItinerary;
  maxMin: { max: number; min: number };
  showYouthStudent: boolean;
  animatedPrice: ReturnValue;
}

export const DesktopButtonInner = (props: IProps) => {
  const {
    selectedItineraryId,
    priceItinerary,
    maxMin,
    showYouthStudent,
    animatedPrice,
  } = props;

  const {
    translations: {
      searchResults: { stops: stopsTranslations },
      timeLabels,
    },
  } = useTranslations();

  const { locale } = useConfig();

  const id = showYouthStudent
    ? priceItinerary.studentOrYouthData.id
    : priceItinerary.id;

  const cellColorStyles: SxProps = {
    ...getCellColor(selectedItineraryId === id, priceItinerary.price, maxMin),
  };

  const { desktopButtonPrice, desktopButtonRow } = sxStyles;

  return (
    <>
      <Box sx={desktopButtonPrice}>
        <Typography variant="h5" sx={{ ...cellColorStyles }}>
          {formatPriceNoCurrency(animatedPrice, locale)}
        </Typography>
        <Typography variant="titleMedium" weight="bold">
          {formatCurrency(priceItinerary.currency, locale)}
        </Typography>
        {showYouthStudent && (
          <InfoIcon
            priceItinerary={priceItinerary}
            selectedItineraryId={selectedItineraryId}
          />
        )}
      </Box>
      <Box sx={desktopButtonRow}>
        <FlightTakeoffIcon sx={{ fontSize: "14px" }} />
        <Typography variant="titleExtraSmall" fontWeight="400">
          {minutesTimeSpan(priceItinerary.departureDuration, timeLabels)}
        </Typography>
        <Typography
          variant="titleExtraSmall"
          fontWeight="400"
          sx={{ flex: "1", textAlign: "end" }}
        >
          {getStops(priceItinerary.departureStops, stopsTranslations)}
        </Typography>
      </Box>
      <Box sx={desktopButtonRow}>
        <FlightLandIcon sx={{ fontSize: "14px" }} />
        <Typography variant="titleExtraSmall" fontWeight="400">
          {minutesTimeSpan(priceItinerary.returnDuration, timeLabels)}
        </Typography>
        <Typography
          variant="titleExtraSmall"
          fontWeight="400"
          sx={{ flex: "1", textAlign: "end" }}
        >
          {getStops(priceItinerary.returnStops, stopsTranslations)}
        </Typography>
      </Box>
    </>
  );
};
